import { useLanguageContext } from "../contexts/LanguagesContext";
import locates from "@core/constants/date-locates";


// `time_zone` (optional, e.g. "UTC") is added to every format so server and browser print the same day; without it nothing changes.
const useDate = ({ time_zone } = {}) => {
  const { language } = useLanguageContext();

  const get_time_and_date_client = (timestamp, locate, options = {}) => {
    const date = new Date(parseInt(timestamp));
    const formatted = date.toLocaleDateString(
      locates[locate || language],
      time_zone ? { timeZone: time_zone, ...options } : options
    );
    return formatted;
  };

  const get_month_and_year_client = (timestamp, locate) => {
    return get_time_and_date_client(timestamp, locate, {
      year: "numeric",
      month: "long",
    });
  };

  const get_month_and_day_client = (timestamp, locate) => {
    return get_time_and_date_client(timestamp, locate, {
      day: "numeric",
      month: "long",
    });
  };

  const get_date_client = (timestamp, locate) => {
    return get_time_and_date_client(timestamp, locate);
  };

  const get_time_client = (timestamp, locate) => {
    return get_time_and_date_client(timestamp, locate, {
      hour: "2-digit",
      minute: "2-digit",
    })?.split(", ")?.[1];
  };

  return {
    get_time_and_date_client,
    get_month_and_year_client,
    get_month_and_day_client,
    get_date_client,
    get_time_client,
  };
};

export default useDate;
